module.exports = __webpack_public_path__ + "static/media/QuietkatLogo.43a96118.avif";